<template>
    <div class="Category">
        <div class="Category_inner">
            <div class="Select">
                <el-select v-model="searchInfo.category" placeholder="请选择类型" size="medium"
                    style="width: 180px;margin-right: 5px" clearable>
                    <el-option v-for="item in categoryList" :key="item.text" :label="item.text" :value="item.text">
                    </el-option>
                </el-select>
                <el-button type="primary" size="medium" @click="getArticlelist">查询
                </el-button>
                <el-button style="float: right" type="primary" size="medium" @click="add">新增</el-button>

            </div>
            <div>
                <el-table :data="pageList" style="width: 100%" max-height="520px">
                    <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
                    <el-table-column prop="title" :show-overflow-tooltip="true" label="名称" align="center">
                    </el-table-column>
                    <el-table-column prop="category" :show-overflow-tooltip="true" label="类型" align="center">
                    </el-table-column>
                    <el-table-column prop="posterUrl" label="封面" align="center">
                        <template slot-scope="scope">
                            <div>
                                <img width="100px" :src="scope.row.posterUrl" alt="">
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="url" :show-overflow-tooltip="true" label="跳转地址" align="center">
                        <template slot-scope="scope">
                            <el-link v-if="scope.row.url" :href="scope.row.url" type="primary" target="_blank">
                                点击跳转</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column prop="abstract" :show-overflow-tooltip="true" label="内容" align="center">
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="250">
                        <template slot-scope="scope">
                            <el-button class="edit_btn" size="mini" @click="handleUpdate(scope.row)">编辑</el-button>
                            <!-- <el-button class="del_btn" size="mini" @click="del(scope)">删除</el-button> -->
                        </template>
                    </el-table-column>

                </el-table>
            </div>
            <!--弹框-->
            <div>
                <el-dialog :title="title" :visible.sync="isShow" width="800px" top="20vh" custom-class="pop-dialog"
                    :before-close="oncancel">
                    <el-form :model="formData" label-position="right" label-width="120px" :rules="rules" ref="formData"
                        class="demo-ruleForm" style="width: 100%">
                        <el-form-item label="标题: " prop="title">
                            <el-input size="small" v-model="formData.title"></el-input>
                        </el-form-item>
                        <el-form-item label="摘要: " prop="abstract">
                            <el-select v-model="formData.category" placeholder="请选择类型" size="medium"
                                style="width: 180px;margin-right: 5px" clearable>
                                <el-option v-for="item in categoryList" :key="item.text" :label="item.text"
                                    :value="item.text">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="封面图片:" prop="posterUrl" class="higher">
                            <upload ref="postUpload" :defaultUrl.sync="formData.posterUrl" />
                        </el-form-item>
                        <el-form-item label="跳转文章: " prop="url">
                            <el-input size="small" v-model="formData.url"></el-input>
                        </el-form-item>
                        <el-form-item label="内容: " prop="abstract">
                            <el-input type="textarea" size="small" v-model="formData.abstract"></el-input>
                        </el-form-item>

                    </el-form>
                    <div style="margin-top: 25px; width: 100%; text-align: center">
                        <el-button @click="oncancel" size="small" class="cancel"
                            style="background: rgba(231, 231, 231, 1)">取消
                        </el-button>
                        <el-button type="primary" @click="onSave" size="small" class="onSave"
                            style="background: rgba(201, 160, 108, 1)">确 定
                        </el-button>
                    </div>
                    <br />
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import upload1 from 'components/FileUpload2'
import upload from 'components/FileUpload'
import { getArticlelist, editArticlelist, delArticlelist, addArticlelist } from '@/assets/js/api'
import { GetCategoryList } from '@/assets/js/api'
import { SaveVideo } from '@/assets/js/api'

export default {
    data: () => ({
        image: '',
        searchInfo: {
            category: ''
        },
        pageList: [],
        categoryList: [],
        options: [],
        // 弹窗
        isShow: false,
        isShowedit: false,
        title: '',
        formData: {
            articleId: 0,
            category: '',
            title: '',
            url: '',
            abstract: '',
            posterUrl: ''
        },
        rules: {
            title: [
                {
                    required: true,
                    message: '请输入标题',
                    trigger: 'change',
                },
            ],

        },
        // 首页优先显示开关
        Id: 0,
        IsOnline: false
    }),
    components: {
        upload, upload1,
    },
    created() {
        this.getArticlelist()
        this.GetCategoryList()
    },

    mounted() {

    },
    methods: {
        // 获取数据
        getArticlelist() {
            getArticlelist(this.searchInfo).then(res => {
                this.pageList = null;
                this.pageList = res.data.Articlemess
            })
        },
        // 获取movie类型数据
        GetCategoryList() {
            GetCategoryList().then(res => {
                this.categoryList = res.data.getcategory
            })
        },
        onReset() {
            this.$refs.postUpload.clearFiles()
            this.$refs.postUpload1.clearFiles()
            this.$refs.fm.resetFields()
        },
        add() {
            this.isShow = true
            this.title = '新增'
        },
        batchUpload(refs) {
            let promiseArr = [];
            refs.map(r => {
                promiseArr.push(
                    new Promise((resolve, reject) => {
                        r.startupload(() => {
                            resolve();
                        });
                    })
                );
            });
            return Promise.all(promiseArr);
        },
        batchUpload1(refs) {
            let promiseArr = [];
            refs.map(r => {
                promiseArr.push(
                    new Promise((resolve, reject) => {
                        r.startupload(() => {
                            resolve();
                        });
                    })
                );
            });
            return Promise.all(promiseArr);
        },
        onSave() {
            this.$refs.formData.validate((valid) => {
                if (!valid) return false
                if (!this.formData.articleId) {
                    this.batchUpload([this.$refs.postUpload]).then(() => {
                        addArticlelist(this.formData).then((res) => {
                            console.log('resresresresres-------' + res.data.code)
                            if (res.data.code != -1) {
                                this.$message.success('保存成功')
                                this.oncancel()
                                this.getArticlelist()
                            } else {
                                this.$message.success('保存失败,检查是否名称重复和没有填全资料')
                            }
                        })
                    })
                }else {
                     this.batchUpload([this.$refs.postUpload]).then(() => {
                        editArticlelist(this.formData).then((res) => {
                            console.log('resresresresres-------' + res.data.code)
                            if (res.data.code != -1) {
                                this.$message.success('保存成功')
                                this.oncancel()
                                this.getArticlelist()
                            } else {
                                this.$message.success('保存失败,检查是否名称重复和没有填全资料')
                            }
                        })
                    })
                }

            })

        },

        oncancel() {
            this.isShow = false
            this.isShowedit = false
            this.formData = {
                articleId: 0,
                category: '',
                title: '',
                url: '',
                abstract: '',
                posterUrl: ''
            }
            this.resetForm('formData')
        },
        //编辑
        handleUpdate(row) {
            this.isShow = true;
            this.title = '编辑'
            this.formData = row
        }
    },

}
</script>

<style lang="scss" scoped>
.Category {
    padding: 20px 20px 10px;

    .Category_inner {
        padding: 20px 30px 30px 30px;
        width: calc(100% - 60px);
        min-height: calc(100vh - 155px);
        background: #fff;
        display: flex;
        flex-direction: column;
        font-size: 12px !important;

        .breadcrumb {
            align-items: center;
            justify-content: center;

            .el-breadcrumb {
                font-size: 15px;
                line-height: 2;
            }
        }
    }
}

.SortManagement {
    padding: 20px 20px 10px;

    .SortManagement_inner {
        padding: 30px;
        width: calc(100% - 60px);
        min-height: calc(100vh - 155px);
        background: #fff;
        display: flex;
        flex-direction: column;

        .breadcrumb {
            align-items: center;
            justify-content: center;

            .el-breadcrumb {
                font-size: 15px;
                line-height: 2;
            }
        }
    }
}
</style>

<style scoped>
.Select {
    margin: 10px 0px;
}

.SortManagement .edit_btn {
    width: auto !important;
    background: rgba(80, 197, 217, 1);
    border-radius: 14px !important;
    color: #fff;
    border: #50C5D9;
}

.SortManagement .edit_btn:hover,
.SortManagement .edit_btn:active,
.SortManagement .edit_btn:focus {
    background: rgba(80, 197, 217, 1);
    color: #fff;
    border: #50C5D9;
}

.SortManagement .del_btn2 {
    width: auto !important;
    background: #E7E7E7;
    border-radius: 14px !important;
    color: #555;
    border: #E7E7E7;
}

.SortManagement .del_btn2:hover,
.SortManagement .del_btn2:active,
.SortManagement .del_btn2:focus {
    background: #E7E7E7;
    color: #555;
    border: #E7E7E7;
}

.SortManagement .del_btn {
    width: auto !important;
    background: #FF5B6C;
    border-radius: 14px !important;
    color: #fff;
    border: #FF5B6C;
}

.SortManagement .del_btn:hover,
.SortManagement .del_btn:active,
.SortManagement .del_btn:focus {
    background: #FF5B6C;
    color: #fff;
    border: #FF5B6C;
}

.Img {
    margin-top: 15px;
}

.video {
    margin-top: 20px;
}
</style>

<style scoped>
>>>.el-dialog__body {
    padding: 10px 20px;
    height: 800%;
}

>>>.el-form-item {
    margin-bottom: 0px;
}

>>>.el-form--label-top .el-form-item__label {
    float: none;
    display: inline-block;
    text-align: left;
    padding: 0;
    line-height: 20px;
}

>>>.el-form-item__error {
    padding-top: 0px;
    top: 95%;
    left: auto;
    right: 0;
}
</style>
